export enum NotificationTypeEnum {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export enum VerticalPositionEnum {
  TOP = 'top',
  BOTTOM = 'bottom',
}

export enum HorizontalPositionEnum {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export interface Position {
  vertical: VerticalPositionEnum;
  horizontal: HorizontalPositionEnum;
}

export interface Notification {
  type: NotificationTypeEnum;
  message: string;
  timeout?: number;
  title?: string;
  position?: Position;
}
